import { useEffect, useState } from 'react'
import { Member } from './bank.types'

interface useLastUsedBankArgs {
  members: Member[] | null
}

export const useLastUsedBank = ({ members }: useLastUsedBankArgs) => {
  const [lastUsedBank, setLastUsedBank] = useState<Member | null>(null)

  useEffect(() => {
    if (members && members.length > 0) {
      const savedBankName = localStorage.getItem('sbpMember')

      if (savedBankName) {
        const savedBank = members.find((bank: Member) => bank.name === savedBankName)

        if (savedBank) {
          setLastUsedBank(savedBank)
        }
      }
    }
  }, [members])

  return lastUsedBank
}
